export default __webpack_public_path__ + "static/media/logo02.bb1988b3.png";